var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"\n    col-form-label\n    font-main font-weight-bold\n    text-white\n    col-heading\n    text-right\n  ",class:_vm.classes},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }